import { render, staticRenderFns } from "./schrader-cellars.vue?vue&type=template&id=809fcbd6&scoped=true"
import script from "./schrader-cellars.vue?vue&type=script&lang=js"
export * from "./schrader-cellars.vue?vue&type=script&lang=js"
import style0 from "./schrader-cellars.vue?vue&type=style&index=0&id=809fcbd6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "809fcbd6",
  null
  
)

export default component.exports